import React, { useMemo } from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Chip from "@material-ui/core/Chip";

import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import LinkIcon from "@material-ui/icons/Link";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EditIcon from "@material-ui/icons/Edit";
import BlockIcon from "@material-ui/icons/Block";

import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";

import { DataGrid } from "@material-ui/data-grid";
import { makeStyles } from "@material-ui/core";

const renderHadwareSerial = (serial) => {
  return serial ? <Chip size="small" label={serial} /> : "";
};

const columns = [
  { field: "state", headerName: "State" },
  { field: "licenseType", headerName: "Type" },
  {
    field: "hardwareId",
    headerName: "Hardware serial",
    renderCell: (cell) => renderHadwareSerial(cell.value),
    width: 250,
  },
  {
    field: "expires",
    headerName: "Expiry date",
    valueFormatter: (params) =>
      params.value ? new Date(params.value).toLocaleDateString() : "",
    width: 150,
  },
  { field: "version", headerName: "Version", width: 120 },
  {
    field: "maxResearches",
    headerName: "Max researches",
    width: 150,
  },
  {
    field: "maxSubjects",
    headerName: "Max subjects",
    width: 150,
  },
  { field: "maxUsers", headerName: "Max users", width: 150 },
  { field: "maxCrfs", headerName: "Max crfs", width: 150 },
];

const useStyles = makeStyles((theme) => ({
  buttonsSpacing: {
    margin: theme.spacing(1),
  },
  grid: {
    background: "white",
  },
  titleMargin: {
    margin: theme.spacing(1, 0, 4, 0),
  },
}));

const LicensesList = (props) => {
  const classes = useStyles();
  let height = 250;
  if (props.height) {
    height = props.height;
  }

  const gridColumns = useMemo(() => {
    const gridColumns = [...columns];
    if (props.mode === "licenses") {
      gridColumns.splice(1, 0, {
        field: "customer",
        headerName: "Customer",
        width: 200,
      });
      gridColumns.splice(1, 0, {
        field: "company",
        headerName: "Company",
        width: 150,
      });
    }
    return gridColumns;
  }, [props.mode]);

  return (
    <>
      <Typography gutterBottom variant="h5" className={classes.titleMargin}>
        Licenses
      </Typography>
      <div style={{ height: height }}>
        <DataGrid
          className={classes.grid}
          rows={props.licenses}
          columns={gridColumns}
          loading={props.loading}
          density={props.density ? props.density : "compact"}
          onRowSelected={props.onRowSelected}
        />
      </div>
      <Grid container direction="row" justify="flex-end" alignItems="center">
        {!props.basic && (
          <>
            {!props.isAddDisabled && (
              <IconButton
                aria-label="add"
                color="primary"
                disabled={props.isAddDisabled}
                onClick={props.onAdd}
              >
                <AddIcon />
              </IconButton>
            )}
            <IconButton
              aria-label="edit"
              color="primary"
              disabled={props.isEditDisabled}
              onClick={props.onEdit}
            >
              <EditIcon />
            </IconButton>
            <IconButton
              aria-label="delete"
              color="secondary"
              disabled={props.isDeleteDisabled}
              onClick={props.onDelete}
            >
              <DeleteIcon />
            </IconButton>
            <Tooltip title="Block license" aria-label="block">
               <span>
                <IconButton
                  aria-label="block"
                  color="primary"
                  disabled={props.isBlockDisabled}
                  onClick={props.onBlock}
                >
                  <BlockIcon />
                </IconButton>
              </span>
            </Tooltip>
          </>
        )}
        <Tooltip title="Link license to hardware" aria-label="link">
          <span>
            <IconButton
              aria-label="link"          
              color="primary"
              disabled={props.isLinkDisabled}
              onClick={props.onLink}
            >
              <LinkIcon />
            </IconButton>
          </span>
        </Tooltip>
        <IconButton
          aria-label="view"
          color="primary"
          disabled={props.isViewDisabled}
          onClick={props.onView}
        >
          <VisibilityIcon />
        </IconButton>
      </Grid>
    </>
  );
};

export default LicensesList;
